// extracted by mini-css-extract-plugin
export var cardIcon = "_80-5";
export var cardIconUnframed = "_80-9";
export var checkboxCard = "_80-0";
export var checkboxCardSelected = "_80-4";
export var disabled = "_80-2";
export var interactive = "_80-1";
export var outerBorder = "_80-3";
export var spacerMedium = "_80-8";
export var spacerSmall = "_80-7";
export var spacerXsmall = "_80-6";